<template>
  <div class="sorting-options" :class="{ mobile: isMobile }">
    <div class="indicator" @click="handleOpen">
      <inline-svg :src="require('@/assets/img/icons/sort_indicator.svg')"></inline-svg>
      <div class="selected-option">{{ selectedSort ? selectedSort.name : "Sort By" }}</div>
    </div>
    <div v-if="showPopup && !isMobile" class="cover" @click="handleClose"></div>
    <div v-if="showPopup" class="sorting-popup">
      <template v-if="isMobile">
        <inline-svg class="clear-icon" :src="require('@/assets/img/icons/clear.svg')" @click="handleClose"></inline-svg>
        <h2 class="popup-title">{{ selectedSort ? selectedSort.name : "Sort By" }}</h2>
      </template>
      <div v-for="item in options" :key="item.value" class="sort-items" @click="sortBy(item)">
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/base/_vars.scss";
.sorting-options {
  position: relative;
  width: 200px;
  justify-content: right;

  .indicator {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    transition: opacity $defaultTransitionTime $defaultTransitionType;

    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }

    .selected-option {
      font-size: 16px;
      font-family: "NHaasGroteskDSPro-55Rg";
    }
  }

  .sorting-popup {
    position: absolute;
    top: 50px;
    min-width: 322px;
    right: 0;
    border: 1px solid black;
    background: white;
    padding-top: 8px;
    padding-bottom: 8px;
    z-index: 3;

    .sort-items {
      font-size: 16px;
      font-family: "NHaasGroteskDSPro-55Rg";
      padding: 8px 16px;
      transition: opacity $defaultTransitionTime $defaultTransitionType;
      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }
    }
  }

  .cover {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  &.mobile {
    width: 100%;

    .indicator {
      justify-content: center;
    }
    .sorting-popup {
      position: fixed;
      top: 0;
      bottom: 0;
      width: 100%;
      border: unset;

      .sorting-items {
        padding-left: 16px;
      }

      .popup-title {
        margin-top: 48px;
        margin-left: 16px;
        margin-bottom: 16px;
        font-size: 32px;
      }

      .clear-icon {
        position: fixed;
        top: 16px;
        right: 16px;
        width: 40px;
        height: 40px;

        transition: opacity $defaultTransitionTime $defaultTransitionType;
        &:hover {
          cursor: pointer;
          opacity: 0.8;
        }
      }
    }
  }
}
</style>

<script>
import InlineSvg from "vue-inline-svg";
import { paramsHelper } from "../../mixin/paramsHelper";

export default {
  components: {
    InlineSvg,
  },
  mixins: [paramsHelper],

  props: {
    options: {
      type: Array,
      default: () => {
        return [
          {
            name: "New Arrivals",
            value: "created_at_asc",
          },
          {
            name: "Price: Low to High",
            value: "price_asc",
          },
          {
            name: "Price: High to Low",
            value: "price_desc",
          },
        ];
      },
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedSort: null,
      showPopup: false,
    };
  },
  watch: {
    "$route.query.sortBy": function (sortBy) {
      this.setSelectedSort(sortBy);
    },
  },
  beforeMount() {
    this.setSelectedSort(this.$route.query?.sortBy);
  },
  methods: {
    handleOpen: function () {
      this.showPopup = !this.showPopup;
    },
    handleClose: function () {
      this.showPopup = false;
    },
    sortBy: function (filterType) {
      this.showPopup = false;
      this.selectedSort = filterType;
      this.updateURLParams("page", 1);
      this.updateURLParams("sortBy", this.selectedSort.value);
      this.$ma.trackEvent({
        action: "Category Sort",
        properties: {
          "Search Sort Criteria": this.selectedSort?.name,
        },
      });
    },
    setSelectedSort: function (sortBy) {
      this.selectedSort = this.options?.find((item) => item.value === sortBy);
    },
  },
};
</script>
